'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_data_CookieAppAuthData(auth) {
  this.Lapp_data_CookieAppAuthData__f_auth = null;
  this.Lapp_data_CookieAppAuthData__f_auth = auth;
}
export { $c_Lapp_data_CookieAppAuthData as $c_Lapp_data_CookieAppAuthData };
$c_Lapp_data_CookieAppAuthData.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_data_CookieAppAuthData.prototype.constructor = $c_Lapp_data_CookieAppAuthData;
/** @constructor */
function $h_Lapp_data_CookieAppAuthData() {
}
export { $h_Lapp_data_CookieAppAuthData as $h_Lapp_data_CookieAppAuthData };
$h_Lapp_data_CookieAppAuthData.prototype = $c_Lapp_data_CookieAppAuthData.prototype;
$c_Lapp_data_CookieAppAuthData.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lapp_data_CookieAppAuthData.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-1435116148), true);
});
$c_Lapp_data_CookieAppAuthData.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_data_CookieAppAuthData)) {
    var x = this.Lapp_data_CookieAppAuthData__f_auth;
    var y = x$0.Lapp_data_CookieAppAuthData__f_auth;
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_BoxesRunTime$().equals__O__O__Z(x, y);
  } else {
    return false;
  }
});
$c_Lapp_data_CookieAppAuthData.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lapp_data_CookieAppAuthData.prototype.productArity__I = (function() {
  return 1;
});
$c_Lapp_data_CookieAppAuthData.prototype.productPrefix__T = (function() {
  return "CookieAppAuthData";
});
$c_Lapp_data_CookieAppAuthData.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lapp_data_CookieAppAuthData__f_auth;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lapp_data_CookieAppAuthData.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "auth";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lapp_data_CookieAppAuthData(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lapp_data_CookieAppAuthData)));
}
export { $isArrayOf_Lapp_data_CookieAppAuthData as $isArrayOf_Lapp_data_CookieAppAuthData };
var $d_Lapp_data_CookieAppAuthData = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_data_CookieAppAuthData, "app.data.CookieAppAuthData", ({
  Lapp_data_CookieAppAuthData: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lapp_data_CookieAppAuthData as $d_Lapp_data_CookieAppAuthData };
//# sourceMappingURL=app.data.-Cookie-App-Auth-Data.js.map
